import * as React from 'react';
import 'mapbox-gl/dist/mapbox-gl.css';

import {
    Accordion, AccordionDetails, AccordionSummary, Box,
    CircularProgress, IconButton, Typography,
} from "@mui/material";
import SouffletsAnalyse from "./final/SouffletsAnalyse";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Synthese from "./Synthese";
import {labelGagnant, tddDelay} from "../Utils";
import MapPersonas from "./final/maps/MapPersonas";


export default function GroupByPersonnae({
                                             resultsByPersona,
                                             resultsParCandidatsByPersona,
                                             resultsParDonneesInseeByPersona,
                                             resultsByBvsSynthese,
                                             resultsGeomByBvsSynthese,
                                             resultsGeomIrisByBvsSynthese,
                                             codeInsee,
                                             showPersonae,
                                             otherResults,
                                             resultsByIris,
                                             mappingBvArrondissement
                                         }) {


    const [souffletWinner, setSouffletWinner] = React.useState(false);
    const [souffletWinnerJuste, setSouffletWinnerJuste] = React.useState(false);
    const [souffletWinnerPeu, setSouffletWinnerPeu] = React.useState(false);
    const [souffletWinnerLargement, setSouffletWinnerLargement] = React.useState(false);


    return (
        <Box sx={{width: "100%", gap: "20px", display: "flex", flexDirection: "column"}}>
            {resultsByPersona &&
                resultsParCandidatsByPersona &&
                resultsParDonneesInseeByPersona &&
                resultsByPersona.winner &&
                resultsParCandidatsByPersona.winner &&
                resultsParDonneesInseeByPersona.winner &&

                <Accordion square={'false'}
                           sx={{
                               boxShadow: 3,
                               borderRadius: 2,
                               borderLeft: "30px solid #0fa64e",
                               mb: 2,
                           }}
                           expanded={souffletWinner}
                >
                    <AccordionSummary
                        expandIcon={<IconButton
                            component="a"
                            sx={{
                                color: "#ffff",
                                backgroundColor: "#ca0680",
                            }}
                            onClick={() => setSouffletWinner(!souffletWinner)}
                        >
                            <ExpandMoreIcon/>
                        </IconButton>}>

                        <Box sx={{width: "100%", display: "flex", flexDirection: "column"}}>
                            <Typography variant="h5">
                                {labelGagnant.winner}
                            </Typography>
                            <Synthese codeInsee={codeInsee}/>
                        </Box>
                    </AccordionSummary>
                    {souffletWinner && <AccordionDetails>
                        <MapPersonas
                            resultsByBvsSynthese={resultsByBvsSynthese}
                            resultsGeomByBvsSynthese={resultsGeomByBvsSynthese}
                            resultsGeomIrisByBvsSynthese={resultsGeomIrisByBvsSynthese}
                            filters={resultsParDonneesInseeByPersona.winner}
                            visible={souffletWinner}
                            resultsByIris={resultsByIris}
                            mappingBvArrondissement={mappingBvArrondissement}
                        />

                        <SouffletsAnalyse
                            resultats={resultsByPersona.winner}
                            resultsParCandidatsNuancesCommune={resultsParCandidatsByPersona.winner}
                            data={resultsParDonneesInseeByPersona.winner}
                            showPersonae={showPersonae}
                            resultsGeomIrisByBvsSynthese={resultsGeomIrisByBvsSynthese}
                            otherResults={otherResults.winner}
                            showIris={true}
                            bvId={"winner"}

                        />
                    </AccordionDetails>}
                </Accordion>}
            {resultsByPersona &&
                resultsParCandidatsByPersona &&
                resultsParDonneesInseeByPersona &&
                resultsByPersona.winnerJuste &&
                resultsParCandidatsByPersona.winnerJuste &&
                resultsParDonneesInseeByPersona.winnerJuste &&
                <Accordion square={'false'}
                           sx={{
                               boxShadow: 3,
                               borderRadius: 2,
                               borderLeft: "30px solid #86c14d", mb: 2,
                           }}
                           expanded={souffletWinnerJuste}
                >
                    <AccordionSummary
                        expandIcon={<IconButton
                            component="a"
                            sx={{
                                color: "#ffff",
                                backgroundColor: "#ca0680",
                            }}
                            onClick={() => setSouffletWinnerJuste(!souffletWinnerJuste)}
                        >
                            <ExpandMoreIcon/>
                        </IconButton>}>
                        <Box sx={{width: "100%", display: "flex", flexDirection: "column"}}>
                            <Typography variant="h5">
                                {labelGagnant.winnerJuste}
                            </Typography>
                            <Synthese codeInsee={codeInsee}/>
                        </Box>
                    </AccordionSummary>
                    {souffletWinnerJuste && <AccordionDetails>
                        <MapPersonas
                            resultsByBvsSynthese={resultsByBvsSynthese}
                            resultsGeomByBvsSynthese={resultsGeomByBvsSynthese}
                            resultsGeomIrisByBvsSynthese={resultsGeomIrisByBvsSynthese}
                            filters={resultsParDonneesInseeByPersona.winnerJuste}
                            visible={souffletWinnerJuste}
                            resultsByIris={resultsByIris}
                            mappingBvArrondissement={mappingBvArrondissement}


                        />

                        <SouffletsAnalyse
                            resultats={resultsByPersona.winnerJuste}
                            resultsParCandidatsNuancesCommune={resultsParCandidatsByPersona.winnerJuste}
                            data={resultsParDonneesInseeByPersona.winnerJuste}
                            showPersonae={showPersonae}
                            resultsGeomIrisByBvsSynthese={resultsGeomIrisByBvsSynthese}
                            otherResults={otherResults.winnerJuste}
                            showIris={true}
                            bvId={"winnerJuste"}
                        />
                    </AccordionDetails>}
                </Accordion>}
            {resultsByPersona &&
                resultsParCandidatsByPersona &&
                resultsParDonneesInseeByPersona &&
                resultsByPersona.winnerPeu &&
                resultsParCandidatsByPersona.winnerPeu &&
                resultsParDonneesInseeByPersona.winnerPeu &&
                <Accordion square={'false'}
                           sx={{
                               boxShadow: 3,
                               borderRadius: 2,
                               borderLeft: "30px solid #eeb408", mb: 2,
                           }}
                           expanded={souffletWinnerPeu}
                >
                    <AccordionSummary

                        expandIcon={<IconButton
                            component="a"
                            sx={{
                                color: "#ffff",
                                backgroundColor: "#ca0680",
                            }}
                            onClick={() => setSouffletWinnerPeu(!souffletWinnerPeu)}
                        >
                            <ExpandMoreIcon/>
                        </IconButton>}>

                        <Box sx={{width: "100%", display: "flex", flexDirection: "column"}}>
                            <Typography variant="h5">
                                {labelGagnant.winnerPeu}
                            </Typography>
                            <Synthese codeInsee={codeInsee}/>
                        </Box>
                    </AccordionSummary>
                    {souffletWinnerPeu && <AccordionDetails>
                        <MapPersonas
                            resultsByBvsSynthese={resultsByBvsSynthese}
                            resultsGeomByBvsSynthese={resultsGeomByBvsSynthese}
                            resultsGeomIrisByBvsSynthese={resultsGeomIrisByBvsSynthese}
                            filters={resultsParDonneesInseeByPersona.winnerPeu}
                            visible={souffletWinnerPeu}
                            resultsByIris={resultsByIris}
                            mappingBvArrondissement={mappingBvArrondissement}
                        />

                        <SouffletsAnalyse
                            resultats={resultsByPersona.winnerPeu}
                            resultsParCandidatsNuancesCommune={resultsParCandidatsByPersona.winnerPeu}
                            data={resultsParDonneesInseeByPersona.winnerPeu}
                            showPersonae={showPersonae}
                            resultsGeomIrisByBvsSynthese={resultsGeomIrisByBvsSynthese}
                            otherResults={otherResults.winnerPeu}
                            showIris={true}
                            bvId={"winnerPeu"}
                        />
                    </AccordionDetails>}
                </Accordion>}
            {resultsByPersona &&
                resultsParCandidatsByPersona &&
                resultsParDonneesInseeByPersona &&
                resultsByPersona.winnerLargement &&
                resultsParCandidatsByPersona.winnerLargement &&
                resultsParDonneesInseeByPersona.winnerLargement &&
                <Accordion square={'false'}
                           sx={{
                               boxShadow: 3,
                               borderRadius: 2,
                               borderLeft: "30px solid #e70a08", mb: 2,
                           }}
                           expanded={souffletWinnerLargement}
                >
                    <AccordionSummary
                        expandIcon={<IconButton
                            component="a"
                            sx={{
                                color: "#ffff",
                                backgroundColor: "#ca0680",
                            }}

                        onClick={() => setSouffletWinnerLargement(!souffletWinnerLargement)}
                        >
                            <ExpandMoreIcon/>
                        </IconButton>}>

                        <Box sx={{width: "100%", display: "flex", flexDirection: "column"}}>
                            <Typography variant="h5">
                                {labelGagnant.winnerLargement}
                            </Typography>
                            <Synthese codeInsee={codeInsee}/>
                        </Box>
                    </AccordionSummary>
                    {souffletWinnerLargement && <AccordionDetails>
                        <MapPersonas
                            resultsByBvsSynthese={resultsByBvsSynthese}
                            resultsGeomByBvsSynthese={resultsGeomByBvsSynthese}
                            resultsGeomIrisByBvsSynthese={resultsGeomIrisByBvsSynthese}
                            filters={resultsParDonneesInseeByPersona.winnerLargement}
                            visible={souffletWinnerLargement}
                            resultsByIris={resultsByIris}
                            mappingBvArrondissement={mappingBvArrondissement}
                        />

                        <SouffletsAnalyse
                            resultats={resultsByPersona.winnerLargement}
                            resultsParCandidatsNuancesCommune={resultsParCandidatsByPersona.winnerLargement}
                            data={resultsParDonneesInseeByPersona.winnerLargement}
                            showPersonae={showPersonae}
                            resultsGeomIrisByBvsSynthese={resultsGeomIrisByBvsSynthese}
                            otherResults={otherResults.winnerLargement}
                            showIris={true}
                            bvId={"winnerLargement"}
                        />
                    </AccordionDetails>}
                </Accordion>}

        </Box>
    );
}
